import * as React from 'react';
import { Route } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../store/rootReducer'
import Navbar from './shared/Navbar';
import AppModal from './ui/AppModal'
import { showAppModal } from '../store/modules/appStateSlice';
import { ThunkDispatch, Action } from '@reduxjs/toolkit';


function Layout(props: any): JSX.Element {
    const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
    const { appState, authStore } = useSelector((state: RootState) => state);
    const navbar = authStore.isAuthenticated && appState.isNavbarVisible ? <Navbar righButtonName={authStore.userName??''} /> : null;
    return (
        <React.Fragment>
            { navbar }
            {props.children}
            <AppModal {...appState.appModalState} closeAppModal={() => dispatch(showAppModal({ isAppModalOpened:false }))} />
        </React.Fragment>
    );
}

//<AppModal
//    open={appState.isAppModalOpened}

///>

export default React.memo(Layout);
